import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { EPUAP_LINKS } from '../../constants'
import s from './rodo.scss';

const RODO_CONTENT = () => <div>
    <p>
      <b>
        Klauzula informacyjna dot. przetwarzania danych osobowych na podstawie
        obowiązku prawnego ciążącego na administratorze (przetwarzanie w
        związku z Ustawą z dnia 17 lutego 2005 r. o informatyzacji
        działalności podmiotów realizujących zadania publiczne)
      </b>
    </p>
    <p>
      <b>
        Tożsamość administratora:
      </b>
    </p>
    <p>
      Administratorem jest GIAP Sp. z o.o. z siedzibą w Warszawie przy ul. Pasaż Ursynowski 1/126, 02-784 Warszawa. Administrator odpowiada
      za zapewnienie funkcjonowania elektronicznej platformy usług e-SPDP.pl.
    </p>
    <p>
      <b>
        Dane kontaktowe administratora:
      </b>
    </p>
    <p>
      Z administratorem można skontaktować się:
    </p>
    <ul>
      <li>
        <p>
          pocztą elektroniczną pod adresem espdp@giap.pl,
        </p>
      </li>
      <li>
        <p>
          listownie, kierując korespondencję na adres siedziby administratora.
        </p>
      </li>
    </ul>
    <p>
      <b>
        Dane kontaktowe inspektora ochrony danych osobowych:
      </b>
    </p>
    <p>
      Administrator wyznaczył inspektora ochrony danych, z którym może Pani/Pan
      skontaktować się poprzez e-mail espdp@giap.pl. Z inspektorem
      ochrony danych może Pani/Pan kontaktować się we wszystkich sprawach dotyczących:
    </p>
    <ul>
      <li>
        <p>
          przetwarzania Pani/Pana danych osobowych przez GIAP Sp. z o.o.,
        </p>
      </li>
      <li>
        <p>
          korzystania przez Panią/Pana z praw związanych z przetwarzaniem danych.
        </p>
      </li>
    </ul>
    <p>
      <b>
        Cele przetwarzania i podstawa prawna:
      </b>
    </p>
    <p>
      Pani/Pana dane są przetwarzane w celu zarządzania Pani/Pana kontem na
      e-spdp.pl i wykorzystywania tego konta:
    </p>
    <ul>
      <li>
        <p>
          w celu realizacji usług online, jakie zostały udostępnione na
          platformie e-spdp.pl powiązanych z kontem użytkownika ePUAP,
        </p>
      </li>
      <li>
        <p>
          w zakresie określonym przepisami powszechnie obowiązującego prawa,
          w tym składania podań i wniosków w oparciu o formularze
          elektroniczne umożliwiające realizację usług publicznych.
        </p>
      </li>
    </ul>
    <p>
      <b>
        Podstawa prawna do przetwarzania danych:
      </b>
    </p>
    <ul>
      <li>
        <p>
          Ustawa z dnia 17 lutego 2005 r. o informatyzacji działalności podmiotów
          realizujących zadania publiczne,
        </p>
      </li>
      <li>
        <p>
          Rozporządzenie Ministra Cyfryzacji z dnia 5 października 2016 r. w sprawie zakresu
          i warunków korzystania z elektronicznej platformy usług administracji publicznej.
        </p>
      </li>
    </ul>
    <p>
      <b>
        Zakres przetwarzanych danych odbiorcy danych lub kategorie odbiorców danych:
      </b>
    </p>
    <p>
      Pani/Pana dane osobowe będą przetwarzane także przez:
    </p>
    <ul>
      <li>
        <p>
          Centralny Ośrodek Informatyki z siedzibą w Warszawie przy Alejach
          Jerozolimskich 132-136, 02-305 Warszawa, świadczący usługi
          utrzymania i rozwoju ePUAP oraz udzielający pomocy użytkownikom w
          zakresie niezbędnym dla realizacji tych zadań,
        </p>
      </li>
      <li>
        <p>
          oraz właściwy do sprawy podmiot publiczny (urząd samorządu gminnego)
          przetwarzający otrzymane dane w zakresie i przez okres określony
          przepisami prawa właściwymi dla gromadzenia i przechowywania
          przez nie dokumentacji odzwierciadlającej odpowiedni proces
          załatwiania spraw (zgodnie z przepisami wymagającymi od tych
          podmiotów zapewnienia tej dokumentacji odpowiedniej ewidencji,
          przechowywania i ochrony na podstawie art. 6 ustawy z dnia 14 lipca
          1983 o narodowym zasobie archiwalnym i archiwach).
        </p>
      </li>
    </ul>
    <p>
      Przetwarzanie danych osobowych obejmuje dane podane przez użytkownika przy
      zakładaniu konta, czyli co najmniej:
    </p>
    <ul>
      <li>
        <p>
          imię (imiona) nazwisko,
        </p>
      </li>
      <li>
        <p>
          adres e-mail,
        </p>
      </li>
      <li>
        <p>
          numer telefonu, telefonu komórkowego, faxu,
        </p>
      </li>
      <li>
        <p>
          PESEL,
        </p>
      </li>
      <li>
        <p>
          adres zamieszkania, adres zameldowania.
        </p>
      </li>
    </ul>
    <p>
      Wraz z zakładaniem konta na e-spdp.pl i korzystaniem z elektronicznych
      usług automatycznie łączone jest tworzone konto e-spdp.pl z kontem
      ePUAP użytkownika, które służy do uwierzytelnienia się użytkownika.
    </p>
    <p>
      Oznacza to, że Pani/Pana dane osobowe będą mogły zostać udostępnione
      podmiotom mającym prawo do potwierdzania profilu zaufanego, czyli:
    </p>
    <ul>
      <li>
        <p>
          konsulom,
        </p>
      </li>
      <li>
        <p>
            urzędom wojewódzkim,
        </p>
      </li>
      <li>
        <p>
          urzędom skarbowym,
        </p>
      </li>
      <li>
        <p>
          Zakładowi Ubezpieczeń Społecznych,
        </p>
      </li>
      <li>
        <p>
          podmiotom mającym zgodę ministra właściwego do spraw informatyzacji
          (obecnie Ministra Cyfryzacji) na potwierdzanie profilu zaufanego w
          punkcie potwierdzającym.
        </p>
      </li>
    </ul>
    <p>
        Udostępnienie będzie następowało wyłącznie po podaniu numeru PESEL lub
        identyfikatora użytkownika konta powiązanego ze złożonym automatycznie wnioskiem.
    </p>
    <p>
      <a href={EPUAP_LINKS.CONFIRMATION_POINT_ADDESSES_LIST} style={{ color: 'inherit' }}> 
        <b>
          Pełna lista punktów potwierdzających profile zaufane dostępna jest na stronie pz.gov.pl.
        </b>
      </a>
    </p>
    <p>
      <b>
        Okres przechowywania danych:
      </b>
    </p>
    <p>
      Dane konta użytkownika e-spdp.pl będą przetwarzane bezterminowo, aż do
      czasu usunięcia tego konta przez użytkownika.
    </p>
    <p>
      W każdej chwili użytkownik ma prawo:
    </p>
    <ul>
      <li>
        <p>
          zapoznać się z danymi osobowymi przetwarzanymi w ramach założonego przez
          siebie konta,
        </p>
      </li>
      <li>
        <p>
          poprawiać te dane oraz
        </p>
      </li>
      <li>
        <p>
          usunąć ich część lub całkowicie usunąć konto na e-spdp.pl –
          korzystając z polecenia „usuń konto” dostępnego w ramach opcji zarządzania kontem.
        </p>
      </li>
    </ul>
    <p>
      <b>
        Prawa podmiotów danych:
      </b>
    </p>
    <p>
      Przysługuje Pani/Panu prawo dostępu do Pani/Pana danych oraz prawo żądania ich
      sprostowania lub usunięcia. Możliwe jest to po uwierzytelnieniu się
      na założonym przez siebie koncie e-spdp.pl w sposób ustalony przez użytkownika tego konta.
    </p>
    <p>
      Zmiana danych konta lub usunięcie konta nie spowoduje jednak:
    </p>
    <ul>
      <li>
        <p>
          zmiany i usunięcia danych ePUAP, jakie zostało automatycznie powiązane
          oraz zmiany i usunięcia danych profilu zaufanego,
        </p>
      </li>
      <li>
        <p>
          zmiany
          i usunięcia danych przekazanych do podmiotów publicznych w ramach
          korzystania z usług publicznych na ePUAP, ponieważ
          administratorami tych danych są te podmioty publiczne
          przetwarzające otrzymane dane w zakresie i przez okres określony
          przepisami prawa właściwymi dla gromadzenia i przechowywania przez
          nie dokumentacji odzwierciadlającej odpowiedni proces załatwiania
          spraw (zgodnie z przepisami wymagającymi od tych podmiotów
          zapewnienia tej dokumentacji odpowiedniej ewidencji, przechowywania
          i ochrony na podstawie art. 6 ustawy z dnia 14 lipca 1983 o
          narodowym zasobie archiwalnym i archiwach).
        </p>
      </li>
    </ul>
    <p>
      <b>
        Prawo wniesienia skargi do organu nadzorczego:
      </b>
    </p>
    <p>
      Przysługuje Pani/Panu również prawo wniesienia skargi do organu nadzorczego
      zajmującego się ochroną danych osobowych w państwie członkowskim
      Pani/Pana zwykłego pobytu, miejsca pracy lub miejsca popełnienia
      domniemanego naruszenia.
    </p>
    <p>
      Prezes Urzędu Ochrony Danych Osobowych (PUODO) ul. Stawki 2 00-193 Warszawa
    </p>
    <p>
      <a href={EPUAP_LINKS.UODO_LINK} style={{ color: 'inherit' }}>
        <b>
          Szczegółowe informacje kontaktowe do UODO są dostępne pod tym linkiem.
        </b>
      </a>
    </p>
    <p>
      <b>
        Informacja o dowolności lub obowiązku podania danych:
      </b>
    </p>
    <p>
      Różne usługi mogą wymagać podawania różnego zakresu danych osobowych
      wymaganego przepisami prawa (w szczególności określonych
      przepisami prawa wzorami podań i wniosków wymaganych do załatwienia
      danej sprawy). Niepodanie kompletnych danych może skutkować
      niemożliwością realizacji usługi lub zwrotną korespondencją wymagającą uzupełnienia danych.
    </p>
  </div>;


export default withStyles(s)(RODO_CONTENT);



// WEBPACK FOOTER //
// src/components/utils/rodo.js